// extracted by mini-css-extract-plugin
export default {"localeSwitcherTrigger":"J7DCAGAkQXTHo14nVn0MGg=="};